import React, {Component} from 'react'
import styles from './styles'
import {Markdown} from 'components'

export class Unsupported extends Component {
  static defaultProps = {
    title: 'Unsupported Country',
    name: 'Unsupported'
  }

  render = () => {
    return (
      <div className={styles.section}>
        <Markdown mdtext={this.props.context.country.unsupportedMessage} />
      </div>
    )
  }
}